import { css } from '@emotion/core'
import * as React from 'react'
import { colors } from '../styles/variables'

const styles = css`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    border: 4px solid ${colors.brand};
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  div:nth-of-type(2) {
    animation-delay: -0.5s;
  }

  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
`

const Loader: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className} css={styles}>
    <div />
    <div />
  </div>
)

export default Loader
